import { useDroppable } from '@dnd-kit/core'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import styles from './form-builder-preview.module.scss'
import { useFormBuilderStore } from '../../../../../entities/form-builder/stores/form-builder.store'
import { FormBuilderDroppableId } from '../../constants/form-builder.constants'
import { useFBField } from '../../form-builder.context'
import { FormActiveItem } from '../../types/form-builder.types'
import { FormBuilderCardConfig } from '../form-builder-card-config/form-builder-card-config'
import { FormItemDroppableCard } from '../form-items-droppable/form-item-droppable-card'

type FormBuilderPreviewProps = {
  className?: string
}

export const FormBuilderPreview = ({ className }: FormBuilderPreviewProps) => {
  const { t } = useTranslation()
  const { setNodeRef } = useDroppable({ id: FormBuilderDroppableId })
  const { value: configValue, setValue: setConfigValue } = useFBField()
  const selectedItems = useFormBuilderStore((state) => state.selectedItems)
  const activeItem = useFormBuilderStore((state) => state.activeItem)
  const setActiveItem = useFormBuilderStore((state) => state.setActiveItem)

  const handleCardActivate = (item: FormActiveItem) => {
    if (item.id !== activeItem?.id) {
      setConfigValue(item.config)
    }
    setActiveItem(item)
  }

  if (activeItem) {
    activeItem.config = { ...activeItem.config, ...configValue }
  }

  return (
    <div
      ref={setNodeRef}
      className={clsx(className, 'pt-3 px-4', styles.previewWrap)}
    >
      {selectedItems.length ? (
        <div className={clsx('d-flex position-relative justify-content-between')}>
          <div className={styles.previewCardWrap}>
            {selectedItems.map((item) => (
              <FormItemDroppableCard
                key={item.seq}
                isActivated={activeItem?.id === item.id}
                item={item}
                onActivate={() => handleCardActivate(item)}
              />
            ))}
          </div>
          {activeItem ? <FormBuilderCardConfig item={activeItem} /> : null}
        </div>
      ) : (
        <div className={clsx(styles.placeholder)}>{t('formBuilder.preview.placeholder')}</div>
      )}
    </div>
  )
}
